import { observable, computed, action } from "mobx";
import { MD5 } from '../utils/md5';

export default class Profile {
    @observable email: string = "";
    @observable name: string = "";
    @observable username: string = "";
    @observable quote: string = "";
    @observable age: number = 0;
    @observable id: number = 0;
    @observable complete: boolean = false;
    @observable loggedInUser: boolean = false;
    localStorage: any;

    get_gravatar(email: string, size: string) {
        size = size || "80px";

        return (
            "https://www.gravatar.com/avatar/" + MD5(email) + ".jpg?s=" + size
        );
    }

    @computed
    get gravatar_url() {
        let gravWidth = 150;
        if (screen.width < 768) {
            gravWidth = 100;
        }

        if (this.email) {
            return this.get_gravatar(this.email, `${gravWidth}px`);
        }
        return `https://www.gravatar.com/avatar/00000000000000000000.jpg?s=${gravWidth}px`;
    }

    @computed
    get logged_in_user() {
        return this.email && this.email.length > 0;
    }

    @computed
    get auth_token_set() {
        if (localStorage.getItem("user")) {
            return true;
        }
        return false;
    }

    constructor(
        email: string,
        age: number,
        name: string,
        username: string,
        quote: string
    ) {
        this.age = age;
        this.name = name;
        this.username = username;
        this.quote = quote;
        this.email = email;

        this.id = Date.now();
        this.complete = false;
    }
}
